// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"218": "MainPage","344": "UserPage","412": "EditUserPage","6": "ProductPage",}[chunkId] + "." + {"218": "92ffd816","344": "9dcd71fd","412": "fc09881c","6": "12c54d76",}[chunkId] + ".css"
}